import { FC } from 'react';
import { chakra } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import { logEvent } from 'features/Analytics/analytics';

import locales from './locales';

interface ReferralEmailInviteButtonProps {
  promoCode: string;
}

const ReferralEmailInviteButton: FC<ReferralEmailInviteButtonProps> = ({
  promoCode,
}) => {
  const MAILTO = `mailto:?subject=${encodeURIComponent(
    locales.invite.subject,
  )}&body=${encodeURIComponent(
    locales.formatString(locales.invite.body, `shine.fr/r/${promoCode}`),
  )}`;

  return (
    <Button
      as={chakra.a}
      href={MAILTO}
      onClick={() =>
        logEvent({
          name: 'Referral Invite By Email Button Clicked',
          usePrefix: false,
        })
      }
    >
      {locales.inviteByEmail}
    </Button>
  );
};

export default ReferralEmailInviteButton;
